var React = require('react');

function Cross (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m.757.757 8.486 8.486m0-8.486L.757 9.243","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.5"}));
}

Cross.defaultProps = {"fill":"none","height":"10","width":"10"};

module.exports = Cross;

Cross.default = Cross;
